import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PageHero, SectionHead, Marquee } from "../editorial/Layout";
import galleries from "./galleries.json";

const RAW_PROJECTS = [
  { topicId: "card1",        n: "01", t: "Av. Roi Albert 1er",    loc: "Cannes",              year: "2024", cat: "Full home", area: "210 m²", wk: "22 wk", big: true },
  { topicId: "salledebains", n: "02", t: "Salle de Bain",         loc: "Alpes-Maritimes",     year: "2024", cat: "Bathroom",  area: "14 m²",  wk: "4 wk" },
  { topicId: "carin",        n: "03", t: "Carin House",           loc: "Mouans-Sartoux",      year: "2022", cat: "Living",    area: "110 m²", wk: "14 wk" },
  { topicId: "card6",        n: "04", t: "Cassin House",          loc: "Cannes",              year: "2023", cat: "Kitchen",   area: "38 m²",  wk: "8 wk" },
  { topicId: "card5",        n: "05", t: "Xihong Residence",      loc: "Cannes",              year: "2024", cat: "Full home", area: "180 m²", wk: "18 wk" },
  { topicId: "spens",        n: "06", t: "Spens Villa",           loc: "Cap d'Antibes",       year: "2023", cat: "Outdoor",   area: "320 m²", wk: "24 wk" },
  { topicId: "mani",         n: "07", t: "Mani Apartment",        loc: "Villefranche",        year: "2023", cat: "Living",    area: "94 m²",  wk: "12 wk" },
  { topicId: "card9",        n: "08", t: "Varin Townhouse",       loc: "Nice",                year: "2022", cat: "Full home", area: "160 m²", wk: "20 wk" },
  { topicId: "jasmin",       n: "09", t: "Jasmin Apartment",      loc: "Cannes",              year: "2022", cat: "Kitchen",   area: "52 m²",  wk: "7 wk" },
  { topicId: "ahma",         n: "10", t: "Ahma House",            loc: "Saint-Laurent-du-Var",year: "2023", cat: "Living",    area: "88 m²",  wk: "10 wk" },
];

const PROJECTS = RAW_PROJECTS.map((p) => ({
  ...p,
  img: (galleries[p.topicId] && galleries[p.topicId][0]) || "/assets/hero-kitchen.png",
}));

const FILTERS = ["All", "Kitchen", "Bathroom", "Living", "Full home", "Outdoor"];
const COUNTS = FILTERS.reduce((acc, f) => {
  acc[f] = f === "All" ? PROJECTS.length : PROJECTS.filter((p) => p.cat === f).length;
  return acc;
}, {});

const PortFilters = ({ active, setActive }) => (
  <section style={{ padding: "32px 96px", borderBottom: "1px solid var(--line)", position: "sticky", top: 88, background: "rgba(239,232,221,0.92)", backdropFilter: "blur(12px)", zIndex: 20 }}>
    <style>{`
      .pf-row { display: flex; align-items: center; justify-content: space-between; gap: 24px; }
      .pf-chips { display: flex; gap: 8px; flex-wrap: wrap; }
      .pf-chip { font-size: 13px; padding: 9px 18px; border-radius: 999px; border: 1px solid rgba(27,31,35,0.15); color: var(--ink); cursor: pointer; background: transparent; transition: all .2s; font-family: inherit; }
      .pf-chip:hover { border-color: var(--ink); }
      .pf-chip.act { background: var(--ink); color: var(--paper); border-color: var(--ink); }
      .pf-chip .ct { color: var(--mute); margin-left: 8px; font-family: 'JetBrains Mono', monospace; font-size: 10px; }
      .pf-chip.act .ct { color: rgba(251,248,242,0.55); }
      .pf-meta { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--mute); letter-spacing: 0.14em; text-transform: uppercase; }
      .pf-sort { display: flex; align-items: center; gap: 12px; font-size: 13px; color: var(--ink); cursor: pointer; }
      @media (max-width: 960px) { .pf-row { flex-direction: column; align-items: stretch; } .pf-sort { display: none; } }
    `}</style>
    <div className="pf-row">
      <div className="pf-chips">
        {FILTERS.map((f) => (
          <button
            key={f}
            className={`pf-chip ${active === f ? "act" : ""}`}
            onClick={() => setActive(f)}>
            {f} <span className="ct">{COUNTS[f]}</span>
          </button>
        ))}
      </div>
      <div className="pf-sort">
        <span className="pf-meta">Sort by</span>
        <span style={{ fontWeight: 500 }}>Recent first ↓</span>
      </div>
    </div>
  </section>
);

const PortGrid = ({ active }) => {
  const visible = active === "All" ? PROJECTS : PROJECTS.filter((p) => p.cat === active);
  return (
    <section style={{ padding: "64px 96px" }}>
      <style>{`
        .pg { display: grid; grid-template-columns: repeat(12, 1fr); gap: 24px; }
        .pg-card { position: relative; overflow: hidden; border-radius: 6px; cursor: pointer; display: block; color: var(--paper); }
        .pg-card .img { position: absolute; inset: 0; background-size: cover; background-position: center; transition: transform .5s; }
        .pg-card:hover .img { transform: scale(1.04); }
        .pg-card .scrim { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.7) 100%); }
        .pg-card .num { position: absolute; top: 16px; left: 18px; font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--paper); letter-spacing: 0.16em; background: rgba(0,0,0,0.4); padding: 5px 9px; border-radius: 2px; backdrop-filter: blur(4px); }
        .pg-card .tag { position: absolute; top: 16px; right: 18px; font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--paper); background: rgba(0,0,0,0.4); padding: 5px 9px; border-radius: 2px; backdrop-filter: blur(4px); letter-spacing: 0.12em; text-transform: uppercase; }
        .pg-card .meta { position: absolute; left: 20px; right: 20px; bottom: 22px; color: var(--paper); }
        .pg-card h3 { font-family: 'Fraunces', serif; font-weight: 400; font-size: 24px; letter-spacing: -0.015em; line-height: 1.1; margin: 0 0 6px; }
        .pg-card.big h3 { font-size: 44px; }
        .pg-card .row { display: flex; align-items: center; justify-content: space-between; font-size: 12.5px; color: rgba(251,248,242,0.88); font-family: 'JetBrains Mono', monospace; letter-spacing: 0.06em; }
        .pg-card.c8 { grid-column: span 8; aspect-ratio: 16 / 9; }
        .pg-card.c4 { grid-column: span 4; aspect-ratio: 4 / 5; }
        .pg-card.c6 { grid-column: span 6; aspect-ratio: 4 / 3; }
        .pg-card.c4t { grid-column: span 4; aspect-ratio: 1 / 1; }
        @media (max-width: 960px) {
          .pg { grid-template-columns: 1fr; }
          .pg-card { grid-column: span 1 !important; aspect-ratio: 4 / 3 !important; }
        }
      `}</style>
      <div className="pg">
        {visible.map((p, i) => {
          const cls = i === 0 ? "c8 big" : i === 1 ? "c4" : i % 5 === 2 || i % 5 === 3 ? "c6" : "c4t";
          return (
            <Link key={p.topicId} to={`/portofolio/${p.topicId}`} className={`pg-card ${cls}`}>
              <div className="img" style={{ backgroundImage: `url(${p.img})` }}></div>
              <div className="scrim"></div>
              <div className="num">{p.n} / {visible.length}</div>
              <div className="tag">{p.cat}</div>
              <div className="meta">
                <h3>{p.t}</h3>
                <div className="row">
                  <span>{p.loc} · {p.area}</span>
                  <span>{p.year} · {p.wk}</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

const PortLocations = () => {
  const locs = [
    { c: "Cannes", n: 64 }, { c: "Mougins", n: 22 }, { c: "Antibes", n: 19 }, { c: "Cap d'Antibes", n: 12 },
    { c: "Nice", n: 18 }, { c: "Villefranche", n: 8 }, { c: "Mouans-Sartoux", n: 5 }, { c: "Saint-Laurent-du-Var", n: 4 },
  ];
  return (
    <section className="ed-section" style={{ background: "var(--paper)" }}>
      <style>{`
        .pl-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; border-top: 1px solid var(--line); border-left: 1px solid var(--line); }
        .pl-cell { padding: 28px 26px; border-right: 1px solid var(--line); border-bottom: 1px solid var(--line); display: flex; align-items: end; justify-content: space-between; min-height: 120px; }
        .pl-cell .c { font-family: 'Fraunces', serif; font-weight: 400; font-size: 28px; letter-spacing: -0.015em; }
        .pl-cell .n { font-family: 'JetBrains Mono', monospace; font-size: 13px; color: var(--clay); letter-spacing: 0.12em; }
        @media (max-width: 960px) { .pl-grid { grid-template-columns: 1fr 1fr; } }
      `}</style>
      <SectionHead
        num="—"
        eyebrow="Where we work"
        title='Six years of <em>Côte d&rsquo;Azur</em>.'
        right="A pinned map by frequency. We rarely travel further than a 40-minute drive from Cannes — site time matters."
      />
      <div className="pl-grid">
        {locs.map((l) => (
          <div key={l.c} className="pl-cell">
            <span className="c">{l.c}</span>
            <span className="n">{l.n}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

function PortofolioPage() {
  const [active, setActive] = useState("All");
  return (
    <main className="page-enter">
      <PageHero
        eyebrow="Portfolio · 04 of 06"
        title={<>A hundred and fifty <em>finished homes</em>.</>}
        lede="Every project we've delivered since 2020. Filter by room, sort by year, click anything to see the full case. Six years of receipts."
        meta={[
          <><strong>{PROJECTS.length}</strong> Projects delivered</>,
          <><strong>10</strong> Côte d'Azur towns</>,
          <><strong>2020 →</strong> Today</>,
        ]}
      />
      <PortFilters active={active} setActive={setActive} />
      <PortGrid active={active} />
      <PortLocations />
      <Marquee items={["Croisette", "La Californie", "Le Cannet", "Vallauris", "Juan-les-Pins", "Cap-Ferrat", "Èze", "Beaulieu-sur-Mer"]} />
    </main>
  );
}

export default PortofolioPage;
